export default __webpack_public_path__ + "static/media/Pokemon_logo2.eacb4b86.png";